import { generateCategoricalChart as r } from "./generateCategoricalChart.js";
import { Area as o } from "../cartesian/Area.js";
import { Bar as i } from "../cartesian/Bar.js";
import { Line as m } from "../cartesian/Line.js";
import { Scatter as a } from "../cartesian/Scatter.js";
import { XAxis as p } from "../cartesian/XAxis.js";
import { YAxis as t } from "../cartesian/YAxis.js";
import { ZAxis as s } from "../cartesian/ZAxis.js";
import { formatAxisMap as x } from "../util/CartesianUtils.js";
var l = r({
  chartName: "ComposedChart",
  GraphicalChild: [m, o, i, a],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: p
  }, {
    axisType: "yAxis",
    AxisComp: t
  }, {
    axisType: "zAxis",
    AxisComp: s
  }],
  formatAxisMap: x
});
export {
  l as ComposedChart
};
